module.exports = (__webpack_require__(/*! dll-reference main_lib */ "dll-reference main_lib"))("./cloudui/js/dhtmlx.adapter.js");